module.exports = __webpack_public_path__ + "img/Picture18.d3b1de85.jpg";